import React from 'react';
import {
  Grid,
  TextField,
  MenuItem,
} from '@mui/material';
import {
  ChipOption,
  ChipSelectList,
  Option,
} from '@marageti/z4-lib';
import { TripMatchStatus } from '@marageti/z4-sdk/lib/travel';
import { canceledStatusesValue } from '../../../hooks/use-trip-match-search';

export const statusChipOptions: ChipOption[] = [
  { key: 1, label: 'Accepted', value: TripMatchStatus.MatchAccepted },
  { key: 2, label: 'Active', value: TripMatchStatus.MatchActive },
  { key: 3, label: 'Sold', value: TripMatchStatus.MatchSold },
  { key: 4, label: 'Postponed', value: TripMatchStatus.MatchPostponed },
  { key: 5, label: 'Inactive', value: TripMatchStatus.MatchInactive },
  { key: 6, label: 'Canceled', value: canceledStatusesValue },
];

export const sortByOptions: Option[] = [
  { title: 'Match Date', value: 'createdAt' },
  { title: 'Departure Date', value: 'departureDate' },
];

export const orderByOptions: Option[] = [
  { title: 'New to Old', value: 'desc' },
  { title: 'Old to New', value: 'asc' },
];

type AgentTripsFiltersProps = {
  disableSortBy?: boolean;
  onChange: (n: string, v: string | string[]) => void;
  searchValue?: string;
  selectedStatusChips: string[];
  sortBy: { field: string, order: string } | undefined;
};

const AgentTripsFilters = ({
  disableSortBy = false,
  onChange,
  searchValue = '',
  selectedStatusChips,
  sortBy,
}: AgentTripsFiltersProps) => (
  <Grid container spacing={{ mobile: 1, desktop: 2 }} mb={4}>
    <Grid item mobile={12} desktop={3}>
      <TextField
        fullWidth
        key="search-term"
        label="Search"
        name="searchTerm"
        onChange={(e) => onChange('fullText', e.target.value)}
        value={searchValue}
      />
    </Grid>
    <Grid item mobile={6} desktop={2}>
      <TextField
        key="sort-by-select"
        label="Sort By"
        name="sort"
        onChange={(e) => onChange('sort', e.target.value)}
        select
        sx={{
          width: '100%',
          '& .MuiSelect-icon > svg > path': { color: 'primary.main' },
        }}
        disabled={disableSortBy}
        value={sortBy?.field}
      >
        {sortByOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.title}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item mobile={6} desktop={2}>
      <TextField
        key="order-by-select"
        label="Order"
        name="order"
        onChange={(e) => onChange('order', e.target.value)}
        select
        sx={{
          width: '100%',
          '& .MuiSelect-icon > svg > path': { color: 'primary.main' },
        }}
        disabled={disableSortBy}
        value={sortBy?.order}
      >
        {orderByOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.title}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
    <Grid item mobile={12} desktop={12}>
      <ChipSelectList
        chipOptions={statusChipOptions}
        label="Status"
        onChange={(v: string[]) => onChange('status', v)}
        selectedChips={selectedStatusChips}
      />
    </Grid>
  </Grid>
);

export default AgentTripsFilters;
